module.exports = __webpack_public_path__ + "images/referenzen/animationsfilm/olympus_diegoelite_productfilm_animation.jpg";